/**
 * orgDisplayPolicy — the ONE place that decides which employees the public
 * org surfaces (/ai-organization + the homepage hero) display.
 *
 * DATA vs DISPLAY: the daily-refreshed org_stats.json (and its baked snapshot
 * copy, orgStatsSnapshot.json) carries EVERY internal employee — this module
 * filters at render time only. Rhea's generator never needs to know about
 * display decisions.
 *
 * To hide an employee (e.g. hired but not yet operating), add their name
 * below; to bring them back, remove the line. One line each way.
 *
 * Current policy (Nitish, Oct 6 2026): nobody is hidden; Aria and Nora work
 * like the rest of the team. (Aug 3 2026: Aria was hidden until she started.)
 */
export const HIDDEN_EMPLOYEES = new Set([]);

// Returns a copy of an org-stats payload with hidden employees removed.
// Consumers apply this to BOTH the baked snapshot and the runtime fetch.
export const filterOrgData = (data) => (
  data && data.employees
    ? { ...data, employees: data.employees.filter((e) => !HIDDEN_EMPLOYEES.has(e.name)) }
    : data
);
